import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { formatarData } from 'src/app/core/utils/utilities';
import { AgendamentoService } from 'src/app/services/AgendamentoService/agendamento.service';
import { CargaService } from 'src/app/services/CargaService/carga.service';
import { ICreateEntradaHigienizacaoAgendadaBody } from 'src/app/services/HigienizacaoAgendadaService/higienizacaoAgendada.model';
import { HigienizacaoAgendadaService } from 'src/app/services/HigienizacaoAgendadaService/higienizacaoAgendada.service';
import { IGetPreco } from 'src/app/services/PrecoService/preco.model';
import { PrecoService } from 'src/app/services/PrecoService/preco.service';
import { ServicoEntradaService } from 'src/app/services/ServicoEntradaService/servicoEntrada.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { IGetTipoCarreta } from 'src/app/services/TipoCarretaService/tipoCarreta.model';
import { TipoCarretaService } from 'src/app/services/TipoCarretaService/tipoCarreta.service';

type IOptions = {
  name: string;
  value: string | number;
};

@Component({
  selector: 'app-cadastro-higienizacao-agendada',
  templateUrl: './cadastro-higienizacao-agendada.component.html',
  styleUrls: ['./cadastro-higienizacao-agendada.component.scss']
})
export class CadastroHigienizacaoAgendadaComponent implements OnInit {
  form: FormGroup;
  title: string = 'HIGIENIZAÇÃO AGENDADA';
  isViewing: boolean = false;
  isLoading: boolean = false;
  idFuncionario = Number(localStorage.getItem('id'));
  guid = generateUUID();
  public precosRaw: any[] = [];

  tipoCarretaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tipoCargaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tipoEixosOptions: IOptions[] = [
    {
      name: '3 Eixos',
      value: 3
    },
    {
      name: '4 Eixos',
      value: 4
    },
    {
      name: '7 Eixos',
      value: 7
    },
    {
      name: '9 Eixos',
      value: 9
    }
  ];

  qtdCompartimentosOptions: IOptions[] = [
    {
      name: '0',
      value: 0
    },
    {
      name: '1',
      value: 1
    },
    {
      name: '2',
      value: 2
    },
    {
      name: '3',
      value: 3
    }
  ];

  precosOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private higienizacaoAgendadaService: HigienizacaoAgendadaService,
    private agendamentoService: AgendamentoService,
    private tipoCarretaService: TipoCarretaService,
    private tipoCargaService: CargaService,
    private servicoEntradaService: ServicoEntradaService,
    public swalAlert: SwalAlertService,
    private precoService: PrecoService
  ) {
    this.form = this.initForm();
  }

  ngOnInit(): void {
    this.activateRoute();
  }

  initForm(): FormGroup {
    const form = this.fb.group({
      FK_AGND: [null, Validators.required],
      QT_CPTM: [null],
      QT_TOTL_EIXO: [null],
      FK_CRGA: [null, Validators.required],
      FK_TIPO_CRRT: [null, Validators.required],
      FK_PGMT_FTRD: [null],
      FK_FUNC_OPER: [this.idFuncionario, Validators.required],
      TX_OBSV_SRVC_ENTR: [null],
      DT_FILA: [null],
      PK_PRCO: this.fb.control(null)
    });
    return form;
  }

  postHigienizacao(): void {
    this.isLoading = true;
    const payload = this.createPayload();
    this.higienizacaoAgendadaService
      .CreateEntradaHigienizacaoAgendada(payload, this.guid)
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.router.navigate(['listagem/higienizacao-agendada']);
        },
        error: err => {
          this.isLoading = false;
          const message =
            err?.error?.Errors?.Error ??
            err?.error?.Error ??
            err?.error?.Message ??
            err?.message ??
            'Não foi possível registrar a higienização agendada.';
          this.swalAlert.showAlert('Atenção!', message, 'warning');
        }
      });
  }

  getAgendamento(): void {
    const numeroAgendamento = this.form.controls['FK_AGND'].value;
    if (!numeroAgendamento) return;

    this.isLoading = true;
    this.agendamentoService
      .GetAgendamentoById(Number(numeroAgendamento))
      .subscribe({
        next: res => {
          this.isLoading = false;
          if (!res?.PK_AGND) {
            this.swalAlert.showAlert(
              'Atenção!',
              'Agendamento não encontrado!',
              'warning'
            );
            this.form.controls['FK_AGND'].reset();
            return;
          }

          if (res.FK_CRGA != null) {
            this.form.controls['FK_CRGA'].setValue(Number(res.FK_CRGA));
            this.form.get('FK_CRGA')?.markAsTouched();
          }

          if (res.FK_TIPO_CRRT != null) {
            this.form.controls['FK_TIPO_CRRT'].setValue(Number(res.FK_TIPO_CRRT));
            this.form.get('FK_TIPO_CRRT')?.markAsTouched();
          }

          this.atualizarPreco();
        },
        error: () => {
          this.isLoading = false;
          this.swalAlert.showAlert(
            'Atenção!',
            'Agendamento não encontrado!',
            'warning'
          );
          this.form.controls['FK_AGND'].reset();
        }
      });
  }

  getTipoCarretaOptions(): void {
    this.isLoading = true;
    this.tipoCarretaService.GetTipoCarreta().subscribe({
      next: res => {
        this.isLoading = false;
        this.tipoCarretaOptions = res.map((x: IGetTipoCarreta) => {
          return {
            name: x.NM_TIPO_CRRT,
            value: x.PK_TIPO_CRRT
          };
        });
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  getTipoCargaOptions(): void {
    this.isLoading = true;
    this.tipoCargaService.GetCarga().subscribe({
      next: res => {
        this.isLoading = false;
        this.tipoCargaOptions = res.map((x: any) => {
          return {
            name: x.TX_CRGA,
            value: x.PK_CRGA
          };
        });
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  createPayload(): ICreateEntradaHigienizacaoAgendadaBody {
    return {
      FK_AGND: this.form.controls['FK_AGND'].value,
      QT_CPTM: this.form.controls['QT_CPTM'].value,
      QT_TOTL_EIXO: this.form.controls['QT_TOTL_EIXO'].value,
      FK_CRGA: this.form.controls['FK_CRGA'].value,
      FK_TIPO_CRRT: this.form.controls['FK_TIPO_CRRT'].value,
      FK_PGMT_FTRD: this.form.controls['FK_PGMT_FTRD'].value,
      FK_FUNC_OPER: this.form.controls['FK_FUNC_OPER'].value,
      TX_OBSV_SRVC_ENTR: this.form.controls['TX_OBSV_SRVC_ENTR'].value,
      PK_PRCO: this.form.controls['PK_PRCO'].value
    };
  }

  activateRoute(): void {
    this.route.queryParams.subscribe(params => {
      if (params['isViewing'] == 'true') {
        this.isViewing = true;
        const id = Number(params['codigo']);
        this.isLoading = false;
        this.getTipoCarretaOptions();
        this.getTipoCargaOptions();
        this.getPrecos();
        this.servicoEntradaService.GetServicoById(id).subscribe({
          next: res => {
            this.form.disable();
            this.form.controls['FK_AGND'].setValue(res.FK_AGND);
            this.form.controls['DT_FILA'].setValue(
              formatarData(res.DT_SRVC_ENTR)
            );
            this.form.controls['QT_CPTM'].setValue(res.QT_CPTM);
            this.form.controls['QT_TOTL_EIXO'].setValue(res.QT_TOTL_EIXO);
            this.form.controls['FK_CRGA'].setValue(res.FK_CRGA);
            this.form.controls['FK_TIPO_CRRT'].setValue(res.FK_TIPO_CRRT);
            this.form.controls['TX_OBSV_SRVC_ENTR'].setValue(
              res.TX_OBSV_SRVC_ENTR
            );
            this.isLoading = false;
          },
          error: () => {
            this.isLoading = false;
          }
        });
        return;
      }
      const dataFila = formatarData(new Date());
      this.form.controls['DT_FILA'].setValue(dataFila);
      this.getTipoCarretaOptions();
      this.getTipoCargaOptions();
      this.getPrecos();
    });
  }

  onSelectChange(event: any, formTarget: string): void {
    if (this.form.controls[formTarget].value !== event) {
      this.form.controls[formTarget].setValue(event);
      this.atualizarPreco();
    }
  }

  getPrecos(): void {
    this.isLoading = true;
    this.precoService.GetPreco({ status: 1, pageSize: 9999 }).subscribe({
      next: res => {
        this.isLoading = false;
        const items: IGetPreco[] = res?.ITEMS ?? [];
        this.precosRaw = items
          .filter(item => this.isPrecoLimpezaAgendada(item))
          .reverse();
        this.precosOptions = this.precosRaw.map((x: IGetPreco) => ({
          name: x.NM_PRCO,
          value: x.PK_PRCO
        }));

        if (!this.isViewing && this.precosRaw.length === 0) {
          this.swalAlert.showAlert(
            'Atenção!',
            'Nenhuma tabela de preço ativa cadastrada para limpeza/higienização agendada.',
            'warning'
          );
        }

        this.atualizarPreco();
      },
      error: () => {
        this.isLoading = false;
        this.swalAlert.showAlert(
          'Atenção!',
          'Não foi possível carregar a tabela de preços de higienização agendada.',
          'warning'
        );
      }
    });
  }

  private isPrecoLimpezaAgendada(item: IGetPreco): boolean {
    const tipo = this.normalizeText(item.TX_TIPO_SRVC);
    const fkServico = Number(item.FK_SRVC);

    return (
      tipo.includes('limpeza a')
    );
  }

  private normalizeText(value?: string | null): string {
    return (value ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  onPrecoSelecionado(precoId: number): void {
    const preco = this.precosRaw.find(p => p.PK_PRCO == precoId);
    if (!preco) return;

    if (this.form.controls['PK_PRCO'].value !== precoId) {
      this.form.controls['PK_PRCO'].setValue(precoId);
    }

    this.form.patchValue({
      FK_TIPO_CRRT: preco.FK_TIPO_CRRT ?? null,
      FK_CRGA: preco.FK_CRGA ?? undefined,
      QT_TOTL_EIXO: preco.QT_TOTL_EIXO ?? null,
      QT_CPTM: preco.QT_CPTM ?? null
    });

    this.form.get('FK_TIPO_CRRT')?.markAsTouched();
    this.form.get('FK_CRGA')?.markAsTouched();
    this.form.get('QT_TOTL_EIXO')?.markAsTouched();
    this.form.get('QT_CPTM')?.markAsTouched();
  }

  private atualizarPreco(): void {
    const FK_TIPO_CRRT = this.toNullableNumber(
      this.form.controls['FK_TIPO_CRRT'].value
    );
    const FK_CRGA = this.toNullableNumber(this.form.controls['FK_CRGA'].value);
    const QT_TOTL_EIXO = this.toNullableNumber(
      this.form.controls['QT_TOTL_EIXO'].value
    );
    const QT_CPTM = this.toNullableNumber(this.form.controls['QT_CPTM'].value);

    // Só resolve preço quando tipo carreta e tipo de carga estão preenchidos.
    if (FK_TIPO_CRRT == null || FK_CRGA == null) {
      this.form.controls['PK_PRCO'].setValue(null);
      return;
    }

    if (!this.precosRaw?.length) {
      return;
    }

    const candidatos = this.precosRaw.filter(p => {
      const precoTipo = this.toNullableNumber(p.FK_TIPO_CRRT);
      const precoCarga = this.toNullableNumber(p.FK_CRGA);
      const precoEixos = this.toNullableNumber(p.QT_TOTL_EIXO);
      const precoCptm = this.toNullableNumber(p.QT_CPTM);

      const tipoOk = precoTipo == null || precoTipo === FK_TIPO_CRRT;
      const cargaOk = precoCarga == null || precoCarga === FK_CRGA;
      const eixosOk =
        QT_TOTL_EIXO == null || precoEixos == null || precoEixos === QT_TOTL_EIXO;
      const cptmOk =
        QT_CPTM == null || precoCptm == null || precoCptm === QT_CPTM;

      return tipoOk && cargaOk && eixosOk && cptmOk;
    });

    if (!candidatos.length) {
      this.form.controls['PK_PRCO'].setValue(null);
      return;
    }

    // Preferência: match mais específico (tipo+carga+eixos+cptm).
    const pontuar = (p: IGetPreco): number => {
      let score = 0;
      if (this.toNullableNumber(p.FK_TIPO_CRRT) === FK_TIPO_CRRT) score += 8;
      if (this.toNullableNumber(p.FK_CRGA) === FK_CRGA) score += 8;
      if (
        QT_TOTL_EIXO != null &&
        this.toNullableNumber(p.QT_TOTL_EIXO) === QT_TOTL_EIXO
      ) {
        score += 2;
      }
      if (QT_CPTM != null && this.toNullableNumber(p.QT_CPTM) === QT_CPTM) {
        score += 2;
      }
      return score;
    };

    const preco = [...candidatos].sort((a, b) => pontuar(b) - pontuar(a))[0];

    if (this.form.controls['PK_PRCO'].value !== preco.PK_PRCO) {
      this.form.controls['PK_PRCO'].setValue(preco.PK_PRCO);
    }
  }

  private toNullableNumber(value: unknown): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const num = Number(value);
    return Number.isNaN(num) ? null : num;
  }
}
